module.exports = __webpack_public_path__ + "img/icon-facebook.241f5fd1.svg";